<template>
<div class="overlay" >
  <div class="upload-image-wrapper" style="width:36.5em;max-height:39em;overflow:auto">
   <div class="close"><button v-on:click="close">X</button></div>
   <div class="upload-image-head" style="font-weight: 600;font-size: x-large" >Authorisation View</div>

   <div style="display: flex;justify-content: space-around;margin-bottom: 30px">
       <div class="users-list">
           <h5 style="font-weight: 600;font-size: large;">Users List</h5>
           <div class="collection" style="margin-top:20px;height: 10em;overflow-y:auto;overflow-x:hidden;width: 13em;">
             <a v-for="(user, key) in userData" :key="key" class="collection-item" :class="{active: user.isActive}"  @click="setActive(user)">{{user.username}}
             </a>
            </div>
        </div>
        <div class="Authorised-Users">
            <h5 style="font-weight: 600;font-size: large;">Authorised Users</h5>
            <div class="collection" style="margin-top:20px;height: 10em;overflow-y: auto;overflow-x:hidden;width: 13em">
             <a v-if="authorised" v-for="(user, key) in authorisedUsers" :key="key" class="collection-item" :class="{active: user.isActive}" @click="setActiveAuthorised(user)" >{{user.username}}</a>
             <a v-else  class="collection-item">No Authorised user</a>
            </div>
        </div>   
   </div>
   <div v-if="!isStart" style="margin-bottom: 20px;display: flex;justify-content: space-around;">
     <a class="waves-effect waves-teal btn" @click="startAuthorisation()" style="border-radius:20px">Add User</a>
     <a class="waves-effect waves-teal btn" @click="removeAuthorisation()" style="border-radius:20px">Remove User</a>
   </div>
   <div v-if="isStart" style="display: inline-table">
     <div class="progress" style="display:flex">
       <div class="indeterminate"></div>
      </div>
      <div>{{message}}</div>
   </div>
   <div v-if="CompletionStatus">Authorisation Successfull.</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'DialogAuthorisationView',
  data() {
  return {
    userData:[],
    newUsers:[],
    isStart: false,
    dialogId: [],
    apiStatus: true,
    authorisedUsers: [],
    authorised: true,
    message:"",
    authorisedUsersId:[],
    dialogCount:0,
    selectAuthorised:[],
    CompletionStatus: false,
  }
  },

mounted(){
  this.getAllusers();
  this.getAuthorisedUsers(this.$store.currentDialogId);
  },

methods : {
    close(){
        this.$store.showAuthorisationView = false;
    },
    removeAuthorisation(){
        var userId = ""
      if(this.selectAuthorised.length == 1){
        this.isStart = true
        userId = this.selectAuthorised[0]
      }else{
           M.toast(
          {
            html:"Please select user"
          }
        )
        this.isStart = false
      }
      if(this.isStart == true){
           return new Promise((resolve, reject) =>{
             var dialogId = this.$store.currentDialogId;
             this.$http.delete("/dialogs/"+dialogId+"/authorization/"+ userId).then(
               response =>{
                if(response.data.status){
                  this.message = "Authorisation removed"
                  this.getAuthorisedUsers(this.$store.currentDialogId)
                  this.CompletionStatus = true
                }else{
                  M.toast({"html":response.data.error_message,"classes":"red"});
                  this.close();
                }               
                 this.isStart = false
                  resolve(response)
                  })
                  response =>{
                    this.message = "error occured Please Try Again..." 
                    reject(response)
                  }
                })
      }else{
      }
    },
    startAuthorisation(){
      this.message = "Initiating Authorisation process for Specified information..."
      if(this.newUsers.length >0){
        this.isStart = true
        this.authorisedUsers.forEach(element => {
        if(this.newUsers.includes(element.id)){
          M.toast(
          {
            html:"User is already Authorised"
          }
          )         
          this.isStart = false
          return;
        }
      });
      }else{
        this.isStart = false
        M.toast(
          {
            html:"please select the users for Authorisation"
          }
        )
      }
      if(this.isStart ==true){
           return new Promise((resolve, reject) =>{
             var dialogId = this.$store.currentDialogId;
             this.$http.post("/dialogs/"+dialogId+"/authorization",this.newUsers).then(
               response =>{
                this.message = "Authorisation added."
                this.getAuthorisedUsers(this.$store.currentDialogId)
                this.CompletionStatus = true
                this.isStart = false
                  resolve(response)
                  })
                  response =>{
                    this.message = "error occured Please Try Again..." 
                    reject(response)
                  }
                })
      }
    },  
     setActive(user) {
      var userData = Object.assign([], this.userData)
      var index = 0
      var vm = this;
      userData.forEach(function (element,index){
        if(user.id == element.id){
          if(element.isActive){
            if(vm.newUsers.length > 0){
              vm.newUsers.forEach(function (elem,ind){
                if(elem == user.id){
                  vm.newUsers.splice(ind,1)
                }
              })
            }else{
              vm.newUsers = []
            }
            userData[index].isActive = false
            vm.userData = userData
          }else if(!element.isActive){
            vm.newUsers.push(element.id)
            userData[index].isActive= true
            vm.userData = userData
          }
        }
      });
    },
    setActiveAuthorised(user){
      var index = 0
      this.selectAuthorised = []
      this.authorisedUsers.forEach(element => {
        index += 1 
        if(user.id == element.id){
          if(element.isActive){
            if(this.selectAuthorised.length > 1){
              this.selectAuthorised.forEach(elem =>{
                if(elem = element.id){
                  this.selectAuthorised.splice(index-1,1)
                }
              })
            }else{
              this.selectAuthorised = []
            }
            this.authorisedUsers[index-1].isActive = false
            this.$set(element,element.isActive,false)
          }else if(!element.isActive){
            this.selectAuthorised.push(element.id)
            this.authorisedUsers[index-1].isActive= true
            this.$set(element,element.isActive,true)
          }
        }else{
          element.isActive = false
          this.$set(element,element.isActive,true)
        }
      });
       M.toast(
          {
            html:"you are about to remove authorisation for particular user"
          }
        )
    },
    getAuthorisedUsers(id){
      this.authorisedUsers = []
      return new Promise((resolve, reject) =>{
        this.$http.get("/dialogs/"+id+"/authorizationUser").then(
          response =>{
            if(response.data != null){
            response.data.forEach(element => {
              this.authorised = true
              element.isActive = false
              this.authorisedUsers.push(element)
            });
            }else{
              this.authorised = false
            }
            resolve(response)
          })
          response =>{
            reject(response)
          }
      })
    },
    getAllusers(){
      return new Promise((resolve, reject) =>{
        this.$http.get("/dialogs/00/users").then(
          response =>{
            if(response.data !=null){
              this.userData = []
            response.data.forEach(element => {
              this.userData.push(element)
            });
            this.userData.forEach(elem => {
              elem.isActive = false
            });
          }
            resolve(response)
          })
          response =>{
            reject(response)
          }
      })  
    } 
    },

}  
</script>

<style scoped>
#id{
  color:white;
  background-color: teal;
}

.overlay{
width:100vw;
height:100vh;
position:fixed;
top:0;
left:0;
background:rgba(0,0,0,.4);
z-index:999;
cursor:initial;
}
.upload-image-wrapper{
box-shadow:2px 2px 3px #888;
left:calc(50% - 150px);
top:calc(50% - 250px);
margin:-8px;
width:300px;
position:fixed;
padding:10px;
text-align:center;
align-content: center;
color:dimgray;
background:#f7f7f7;
z-index:10;
animation: grow .25s;
}

@keyframes grow {
  from {
    transform: scale(0.75) ;
  }
  to {
    transform:  scale(1) ;
  }
}

.close{
width:20px;
height:20px;
position:absolute;
right:5px;
top:0px;
}
.close button{
background:none;
border:0px;
font-weight:600;
}
 button:hover{
cursor:pointer;
color: red;
}
.upload-image-head,.update-image-head{
padding:10px;
font-size:22px;
}
</style>